import React from 'react';
import Layout from '../Layout';

const CarouselView = (props) => (
  <Layout {...props} type="CarouselView"/>
)
export default CarouselView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/CarouselView.js